import { Vehicle } from "../../../api/vehiclesApi";
import { LabelPosition } from "./markerUtils";

export const calculateThreshold = (zoom: number): number => {
  const baseThreshold = 0.01;
  const zoomFactor = Math.pow(2, zoom - 10);
  return baseThreshold / zoomFactor;
};

export const getOptimalPositions = (count: number): LabelPosition[] => {
  switch (count) {
    case 1:
      return ["top"];
    case 2:
      return ["top", "bottom"];
    case 3:
      return ["top", "bottomLeft", "bottomRight"];
    case 4:
      return ["top", "right", "bottom", "left"];
    case 5:
      return ["top", "topRight", "bottomRight", "bottomLeft", "topLeft"];
    case 6:
      return [
        "top",
        "topRight",
        "bottomRight",
        "bottom",
        "bottomLeft",
        "topLeft",
      ];
    case 7:
      return [
        "top",
        "topRight",
        "right",
        "bottomRight",
        "bottomLeft",
        "left",
        "topLeft",
      ];
    default:
      return [
        "top",
        "topRight",
        "right",
        "bottomRight",
        "bottom",
        "bottomLeft",
        "left",
        "topLeft",
      ];
  }
};

export const isPositionOccupied = (
  position: LabelPosition,
  vehicle: Vehicle,
  occupiedPositions: Map<number, LabelPosition>,
  vehicles: Vehicle[],
  threshold: number
): boolean => {
  const nearbyVehicles = getNearbyVehicles(vehicle, vehicles, threshold);
  return nearbyVehicles.some((v) => occupiedPositions.get(v.id) === position);
};

export const getNearbyVehicles = (
  vehicle: Vehicle,
  vehicles: Vehicle[],
  threshold: number
): Vehicle[] => {
  return vehicles.filter(
    (v) =>
      v.id !== vehicle.id &&
      Math.abs((v.lastLatitude || 0) - (vehicle.lastLatitude || 0)) <
        threshold &&
      Math.abs((v.lastLongitude || 0) - (vehicle.lastLongitude || 0)) <
        threshold
  );
};

export const getLabelPosition = (
  vehicle: Vehicle,
  vehicles: Vehicle[],
  occupiedPositions: Map<number, LabelPosition>,
  threshold: number
): LabelPosition => {
  const nearbyVehicles = getNearbyVehicles(vehicle, vehicles, threshold);

  if (nearbyVehicles.length === 0) return "top";

  const groupSize = nearbyVehicles.length + 1;
  const optimalPositions = getOptimalPositions(groupSize);

  const allVehiclesInGroup = [...nearbyVehicles, vehicle].sort((a, b) => {
    if ((a.lastLatitude || 0) !== (b.lastLatitude || 0))
      return (b.lastLatitude || 0) - (a.lastLatitude || 0);
    return (a.lastLongitude || 0) - (b.lastLongitude || 0);
  });

  const index = allVehiclesInGroup.findIndex((v) => v.id === vehicle.id);

  return optimalPositions[index] || "top";
};
